import { useQuery } from "@tanstack/react-query";
import { getDecisions, getDecisionLogProjectById } from "../../../../Api/services/decision-log";
import { useAIStream } from "../../../../Hooks/useAiStream";

export const useDecisionLogData = (projectId, projectFormContext) => {
	const { setInitialState } = projectFormContext;

	const {
		data: decisions,
		isFetching: isLoadingDecisions,
		refetch: refetchDecisions,
	} = useQuery({
		queryKey: ["decision-log-decisions", projectId],
		queryFn: () => {
			return getDecisions(projectId);
		},
	});

	const { data: project, refetch: refetchProject } = useQuery({
		queryKey: ["decision-log-project", projectId],
		queryFn: async () => {
			const result = await getDecisionLogProjectById(projectId);

			setInitialState({
				name: result.name,
				description: result.description,
			});

			return result;
		},
	});

	const { data: decisionLogsStream, makeRequest: queryDecisionLogs } = useAIStream({
		url: "/api/decision-log/decisions/query",
	});

	return {
		decisions,
		project,
		decisionLogsStream,
		isLoadingDecisions,
		refetchDecisions,
		refetchProject,
		queryDecisionLogs,
	};
};
